<template>
  <Layout :stylex="{paddingLeft: '320px'}">
    <Content
      :style="{ backgroundColor: '#fff', minHeightx: '600px', width: '100%', marginTop: '60px', marginBottomXXXForFotter: '100px', padding: '20px 25px'}" >
      <Users></Users>
    </Content>
  </Layout>
</template>

<script>
import Users from "../components/Users.vue";

export default {
  components: {
    Users
  }
};
</script>